import { isContentEditable } from "@testing-library/user-event/dist/utils";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { EditText } from "react-edit-text";
import MtfArrow from "../../../../assets/icons/mtfArrow";
import SingleOption from "./singleOption";
import { useDispatch, useSelector } from "react-redux";
import { addMtfOption, removeMtfOption, removeMtfQuestionIdFromOptions, updateSelectedComponentType } from "../../../../redux/slices/userActivity";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";

const OptionsContainer = ({ options, styles, optionWithImage }) => {
  // console.log(styles);

  const dispatch = useDispatch();
  const { selectedUserActivity, selectedComponent } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen, showAnswers } = useSelector((state) => state.preview);

  const { width } = useWindowDimensions();

  // const [dragableOptions, setDragableOptions] = useState([...data.line2]);

  // const onDragEnd = (result) => {
  //   console.log(result);

  //   if (result.destination === null) return;
  //   let newArr = [...dragableOptions];
  //   [newArr[result.source.index], newArr[result.destination.index]] = [newArr[result.destination.index], newArr[result.source.index]];
  //   setDragableOptions(newArr);
  // };
  // function getStyle(style, snapshot) {
  //   if (!snapshot.isDropAnimating) {
  //     return style;
  //   }
  //   return {
  //     ...style,
  //     // cannot be 0, but make it super tiny
  //     transitionDuration: `0.001s`,
  //   };
  // }

  const addNewOption = () => {
    if (options.length >= 5) return;
    const newOption = {
      id: Math.floor(Math.random() * 1000000000),
      created_at: "2022-06-27T05:43:53.537214Z",
      updated_at: "2022-06-27T05:43:53.537233Z",
      l_option: "Text",
      r_option: "Text",
      l_video_url: null,
      r_video_url: null,
      created_by: 1,
    };
    dispatch(addMtfOption({ selectedActivityIdx: selectedUserActivity, newOption }));
  };

  const removeOption = (id) => {
    if (options.length <= 2) return;
    // console.log(id);
    dispatch(removeMtfOption({ selectedActivityIdx: selectedUserActivity, selectedOptionIdx: id }));
  };

  const handleImageClick = (item) => {
    dispatch(
      updateSelectedComponentType({
        type: "image",
        name: "mtf_option_image",
        optionId: item.id,
      })
    );
  };
  if (styles === undefined) return
  return (
    <div style={{ alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "space-around", marginTop: "1rem", marginBottom: "2rem", width: "max-content" }}>
      {!optionWithImage ? (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {options.map((item, index) => {
            return (
              <div key={index} className="@optionContainer activity_container__option_container"
                style={styles ? { ...styles.optionContainer } : {}}
                //  style={styles.optionContainer}
                id={previewModalOpen ? "previewing" : ""}>
                <SingleOption option={item} optionKey="l_option" style={styles} />

                <MtfArrow />

                <SingleOption option={item} optionKey="r_option" style={styles} />

                {options.length > 2 ? (
                  <div className=" activity_container__option_remove_btn" onClick={() => removeOption(item.id)}>
                    <img src="/assets/icons/close.svg" alt="" />
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className=" options_with_image">
          {options.map((item, index) => {
            return (
              <div
                key={index}
                style={styles.optionContainer}
                className={`${width <= 700 ? "d-flex" : "d-block"}  @optionContainer  activity_container__option_container`}
                id={previewModalOpen ? "previewing" : ""}
              >
                <div className={`@imageOption option_with_image ${selectedComponent.optionId === item.id ? "selected" : ""}`} onClick={() => handleImageClick(item)} style={styles.imageOption}>
                  {item.l_image_data !== undefined ? <img src={item.l_image_data.uri} /> : <img src={item.l_image} />}
                </div>

                <SingleOption option={item} optionKey="r_option" style={styles} />

                {options.length > 2 ? (
                  <div className=" activity_container__option_remove_btn" onClick={() => removeOption(item.id)}>
                    <img src="/assets/icons/close.svg" alt="" />
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      )}
      {!previewModalOpen && (
        <div className="activity_container__option_modify_btns">
          <img src="/assets/icons/AddIcon.svg" alt="" onClick={addNewOption} />
          <img src="/assets/icons/RemoveIcon.svg" style={{ marginRight: 0 }} alt="" onClick={() => removeOption(options[options.length - 1].id)} />
        </div>
      )}
    </div>
  );
};

export default OptionsContainer;

// <DragDropContext onDragEnd={onDragEnd}>
// <div>
//   {!optionWithImage ? (
//     <div style={{ display: "flex" }}>
//       <div>
//         {data.line1.map((item, index) => {
//           return (
//             <div style={styles.optionContainer}>
//               <div style={styles.option}>{data.line1[index]}</div>
//               <MtfArrow />
//             </div>
//           );
//         })}
//       </div>
//       <Droppable droppableId={`mtfOptions`}>
//         {(provided) => (
//           <div ref={provided.innerRef} {...provided.droppableProps}>
//             {dragableOptions.map((item, index) => {
//               return (
//                 <Draggable style={{ marginBottom: "20px" }} draggableId={item + index} index={index}>
//                   {(provided, snapshot) => (
//                     <>
//                       <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
//                         <div style={styles.option}>{item}</div>
//                       </div>
//                       {/* {snapshot.isDragging ? (
//                         <div>
//                           <div className="" style={{ ...styles.option, opacity: "0.5" }}>
//                             {item}
//                           </div>
//                         </div>
//                       ) : (
//                         ""
//                       )} */}
//                     </>
//                   )}
//                 </Draggable>
//               );
//             })}
//             {provided.placeholder}
//           </div>
//         )}
//       </Droppable>
//     </div>
//   ) : (
//     <div className=" row options_with_image">
//       {data.line1.map((item, index) => {
//         return (
//           <div key={index} className="col-lg-3 d-flex d-lg-block">
//             <div className="option_with_image  " style={styles.optionWithImage}>
//               <img src={item} alt="" />
//             </div>
//           </div>
//         );
//       })}
//       {dragableOptions.map((item, index) => {
//         return (
//           <Droppable key={index} droppableId={`mtfOptions-${index}`}>
//             {(provided) => (
//               <div ref={provided.innerRef} {...provided.droppableProps} style={{ overflow: "hidden" }} className="col-lg-3 d-flex d-lg-block">
//                 <Draggable draggableId={item + index} index={index}>
//                   {(provided, snapshot) => (
//                     <>
//                       <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} style={getStyle(provided.draggableProps.style, snapshot)}>
//                         <div className="" style={styles.option}>
//                           {item}
//                         </div>
//                       </div>
//                       {snapshot.isDragging ? (
//                         <div>
//                           <div className="" style={{ ...styles.option, opacity: "0.5" }}>
//                             {item}
//                           </div>
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                     </>
//                   )}
//                 </Draggable>

//                 {/* {provided.placeholder} */}
//               </div>
//             )}
//           </Droppable>
//         );
//       })}
//     </div>
//   )}
// </div>
// </DragDropContext>
